//* Google Tag Manager
export const REACT_APP_GTM_ID = 'GTM-NFQQRFPD';
export const TAG_MANAGER_ARGS = {
    gtmId: REACT_APP_GTM_ID,
}